export default __webpack_public_path__ + "d176e439c51645dd7435c7cf6aefba7f.png";